import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X, Plus, ArrowUpRight } from 'lucide-react';
import { QUICK_CREATE } from './osConfig';
import { useOverlay } from './osPrimitives';

// Quick Create sheet — routes to existing authoritative flows (no new write path in R1).
export default function OSQuickCreate({ open, onClose }) {
  const navigate = useNavigate();
  useOverlay(open, onClose);
  if (!open) return null;
  const go = (to) => { onClose(); navigate(to); };
  return (
    <div className="fixed inset-0 z-[120] flex items-end sm:items-center sm:justify-center"
         style={{ background: 'rgba(0,0,0,.72)', backdropFilter: 'blur(6px)' }}
         onClick={onClose} data-testid="os-quick-create-overlay">
      <div className="os-elev w-full sm:max-w-md sm:rounded-2xl rounded-t-2xl overflow-hidden os-animate"
           onClick={(e) => e.stopPropagation()}
           style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}>
        <div className="flex items-center justify-between px-5 py-4 border-b" style={{ borderColor: 'var(--os-border)' }}>
          <div className="flex items-center gap-2">
            <Plus className="h-5 w-5" style={{ color: 'var(--os-red)' }} />
            <h3 className="os-display text-xl">QUICK CREATE</h3>
          </div>
          <button onClick={onClose} className="p-1" style={{ color: 'var(--os-muted)' }} data-testid="os-quick-create-close"><X className="h-5 w-5" /></button>
        </div>
        <div className="p-3">
          {QUICK_CREATE.map((a) => (
            <button key={a.id} onClick={() => go(a.to)} data-testid={a.id}
                    className="os-card w-full flex items-center justify-between px-4 py-3 mb-2 text-left">
              <div>
                <p className="font-bold text-sm" style={{ color: 'var(--os-text)' }}>{a.label}</p>
                <p className="text-xs" style={{ color: 'var(--os-muted)' }}>{a.hint}</p>
              </div>
              <ArrowUpRight className="h-4 w-4" style={{ color: 'var(--os-muted)' }} />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
